// Reviews data — real 5-star Google reviews for Claim Beast Public Adjusters.
// Each review supports: name, location (city), rating (1-5), claimType, text, date, source.

export const reviewStats = {
  averageRating: 5.0,
  totalReviews: 10,
  fiveStarPercentage: 100,
};

export const reviews = [
  {
    id: 1,
    name: "Kim Goodwin",
    location: "Tampa Bay, FL",
    rating: 5,
    claimType: "Industry Partner",
    date: "2026-01-22",
    source: "Google",
    text: "Joe Singer with Claim Beast Public Adjusters has been an incredible resource for both my clients and our team at Steadfast Roofing. I've personally seen Joe step in during some very stressful situations, especially when homeowners felt defeated, overwhelmed, or were dealing with denied insurance claims and didn't know where to turn. His knowledge, communication, professionalism, and dedication to helping people truly stand out. He takes the time to educate clients, advocate for them, and fight for fair outcomes. What I appreciate most is that Joe genuinely cares. He treats people with respect, keeps them informed throughout the process, and works hard to help homeowners navigate difficult claim situations. In this industry, integrity matters, and Joe has been exceptional. I'm grateful to have a trusted professional like Joe that I can confidently recommend to my clients. Highly recommend Joe Singer and Claim Beast Public Adjusters.",
    featured: true,
  },
  {
    id: 2,
    name: "Jessica Ewen",
    location: "Tampa Bay, FL",
    rating: 5,
    claimType: "Denied Claim Reopen",
    date: "2026-01-15",
    source: "Google",
    text: "Highly recommend! Going with Claim Beast Public Adjusters was one of the best decisions I've made. Their integrity, grit, and dedication showed throughout the entire claims process & Joe fought hard to get us a much higher payout than we expected. Professional, responsive, and truly on the client's side from start to finish.",
    featured: true,
  },
  {
    id: 3,
    name: "Tabby Mcneilly",
    location: "Tampa, FL",
    rating: 5,
    claimType: "Wind Damage",
    date: "2025-09-12",
    source: "Google",
    text: "I had a great experience working with Claim Beast on my wind damage claim in Tampa. From the very beginning, they were professional, responsive, and knowledgeable. They took the time to explain the process, handled all the communication, and made sure nothing was overlooked. Thanks to their expertise, my claim was handled smoothly and the outcome was far better than I could have managed on my own. They truly had my best interests in mind and made a stressful situation much easier to deal with. If you're dealing with wind damage or an insurance claim, I highly recommend Claim Beast.",
    featured: true,
  },
  {
    id: 4,
    name: "Tyler Orrick",
    location: "Tampa Bay, FL",
    rating: 5,
    claimType: "Verified Google Review",
    date: "2025-10-15",
    source: "Google",
    text: "Mr. Joe is an absolute pleasure to work with. He's the kind of businessman where a handshake still means something. Communication is clear and consistent, expectations are straightforward, and the payouts have been completely sufficient! Solid work from start to finish. I wouldn't hesitate to recommend Joe to anyone. Peace and blessings brother, it's been a pleasure to work with you! and THANK YOU!",
    featured: true,
  },
  {
    id: 5,
    name: "Ally Santos",
    location: "Tampa Bay, FL",
    rating: 5,
    claimType: "Verified Google Review",
    date: "2026-02-01",
    source: "Google",
    text: "Just want to say I had a really solid experience with this public adjuster company. Victoria was the main person I dealt with and she was great from start to finish. Super helpful, patient, and always quick to respond whenever I had questions. She really made the whole process feel less overwhelming and actually took the time to make sure I understood what was going on with my claim. You can tell she knows what she's doing and actually cares about her clients. Definitely appreciate her help and would recommend working with her.",
    featured: false,
  },
  {
    id: 6,
    name: "Luis Amador Gomez",
    location: "Tampa Bay, FL",
    rating: 5,
    claimType: "Verified Google Review",
    date: "2026-02-01",
    source: "Google",
    text: "Had a really good experience with Claim Beast Public Adjusters. They were professional, responsive, and actually took the time to explain the whole process instead of just rushing through it. Dealing with insurance can be stressful, but they made everything a lot easier and kept me updated along the way. You can tell they genuinely care about helping their clients and fighting to get things handled the right way. Definitely recommend them if you ever need a public adjuster.",
    featured: false,
  },
  {
    id: 7,
    name: "Alexander Parra",
    location: "Tampa Bay, FL",
    rating: 5,
    claimType: "Verified Google Review",
    date: "2026-01-18",
    source: "Google",
    text: "Awesome business & great people. The service and the seamless help it is amazing. Best quality is the Joe Singer with knowledge & excellent guidance through the process. He cares for his clients.",
    featured: false,
  },
  {
    id: 8,
    name: "Heath Hatchett",
    location: "Tampa Bay, FL",
    rating: 5,
    claimType: "Verified Google Review",
    date: "2026-02-01",
    source: "Google",
    text: "Probably the best adjuster in the game right now! Always working to take care of the customer.",
    featured: false,
  },
  {
    id: 9,
    name: "Jenny Brooks",
    location: "Tampa Bay, FL",
    rating: 5,
    claimType: "Verified Google Review",
    date: "2026-02-24",
    source: "Google",
    text: "Joseph is a BEAST and helped us tremendously with our insurance claim and was able to fight to get the accurate funds needed to fully repair our home from the Insurance Co. I highly recommend!!",
    featured: false,
  },
  {
    id: 10,
    name: "Zachariah Addison",
    location: "Lutz, FL",
    rating: 5,
    claimType: "Verified Google Review",
    date: "2026-02-24",
    source: "Google",
    text: "Joe and his team took great care of us. Did a great job explaining the process, taking care of all of the details and helping us get our claim settled and approved. Highly recommend him to anybody. He came to Lutz to help us out and he serves the entire Tampa Bay region.",
    featured: false,
  },
];
